export default "__VITE_ASSET__4fdf444e__"